// extracted by mini-css-extract-plugin
module.exports = {"datepicker":"styles_datepicker__GyOxS","rangepicker":"styles_rangepicker__3z2xU"};